var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"summary-card text-center h-100"},[_c('div',{staticClass:"summary-count"},[_vm._v(_vm._s(_vm.count))]),_vm._v(" "),_c('h5',{staticClass:"summary-title mb-2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('p',{staticClass:"summary-subtitle text-muted mb-0"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }